import request from '@/utils/request'; //获取背包详情

export function getBackpackDetail(data) {
  return request({
    url: '/datum/bag_desc',
    method: 'get',
    params: data
  });
}
export function yjBagDesc(data) {
  return request({
    url: '/datum/yj_bag_desc',
    method: 'get',
    params: data
  });
}